import React, { Fragment, useState, useRef } from "react";
import { Row, Col, Container } from "reactstrap";
//import UpdateProfileService from '../../services/UpdateProfile';
import Loader from "react-loader-spinner";
import AuthService from "../../services/AuthService";
//import cookie from "react-cookies";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import { userInfoAction } from "../../reducers/UserReducer";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../StudentProfile/StudentProfile.scss";

const RecruiterProfile = () => {
  const dispatch = useDispatch();
  let scrollToSuccess = useRef();
  const [loading, setLoading] = useState(false);
  const [nextClicked, setNextClicked] = useState(false);
  const [cancelClicked, setCancelClicked] = useState(false);
  //const [user  , setUser ] = useState(localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')));
  const user = useSelector((state) => state.UserReducer?.userObj);
  const [firstName, setFirstName] = useState(user && user.first_name);
  const [lastName, setLastName] = useState(user && user.last_name);
  const [email, setEmail] = useState(user && user.email);
  const [mobile, setMobile] = useState(user && user.mobile);
  const [recoveryEmail, setRecoveryEmail] = useState(
    user && user.recovery_email,
  );
  const [language, setLanguage] = useState(user && user.language);
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [showError, setShowError] = useState(false);
  const [profileSavedSuccessfully, setProfileSavedSuccessfully] = useState(
    false,
  );
  //const [checkBoxOpportunity, setCheckBoxOpportunity] = useState();
  let history = useHistory();

  const onNextClick = () => {
    // setNextClicked(true);
    if (confirmPassword && password !== confirmPassword) {
      setShowError(true);
      return;
    } else if (!firstName || !lastName || !mobile || !email || !recoveryEmail) {
      swal({
        text:
          "Please fill in all required fields (First Name, Last Name, Mobile, Email & Secondary Email)",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true,
        },
        closeOnClickOutside: false,
      });
      return;
    }
    let obj = {};
    // if (firstName) {
    obj.first_name = firstName;
    // }
    // if (lastName) {
    obj.last_name = lastName;
    // }
    // if (email) {
    obj.email = email;
    // }
    // if (mobile) {
    obj.mobile = mobile;
    // }
    if (language) {
      obj.language = language;
    }
    // if (recoveryEmail) {
    obj.recovery_email = recoveryEmail;
    // }
    if (password) {
      obj.password = password;
    }
    if (confirmPassword) {
      obj.confirm_password = confirmPassword;
    }
    let finalObj = {};
    Object.assign(finalObj, user, obj);
    setLoading(true);
    AuthService.updateProfile(obj)
      .then((data) => {
        setNextClicked(false);
        setLoading(false);
        //cookie.save('user', JSON.stringify(finalObj), {path:'/', domain:'.siembramobile.com'})
        localStorage.setItem("user", JSON.stringify(finalObj));
        setProfileSavedSuccessfully(true);
        dispatch(userInfoAction(finalObj));
        swal({
          text: "Profile updated successfully",
          icon: "success",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
            },
          },
          closeOnClickOutside: false,
        });
        setTimeout(() => {
          setProfileSavedSuccessfully(false);
        }, 3500);
      })
      .catch((error) => {
        //   setNextClicked(false);
        setLoading(false);
        if (error && error.response.status === 400) {
          if (error?.response?.data?.mobile) {
            swal({
              text: error?.response?.data?.mobile[0],
              icon: "warning",
              dangerMode: true,
              buttons: {
                cancel: true,
              },
              closeOnClickOutside: false,
            });
          } else if (error?.response?.data?.recovery_email) {
            swal({
              text: error?.response?.data?.recovery_email[0],
              icon: "warning",
              dangerMode: true,
              buttons: {
                cancel: true,
              },
              closeOnClickOutside: false,
            });
          }
        } else if (error?.response?.status === 409) {
          const msg =
            error?.response?.data?.Message ||
            error?.response?.data?.message ||
            "Conflict";
          swal({
            text: msg,
            icon: "error",
            buttons: {
              confirm: {
                text: "OK",
                value: true,
              },
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const scrollFunction = () => {
    scrollToSuccess.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };
  const onCancelClick = () => {
    if (user?.role === "recruiter") {
      history.push("/recruiter/search-query");
    } else if (
      user?.role === "counselor" &&
      user?.is_super_counselor === false
    ) {
      history.push("/counselor/all-students");
    } else if (
      user?.role === "counselor" &&
      user?.is_super_counselor === true
    ) {
      history.push("/super_admin/all-students");
    }
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner student-profile-info-main">
            <Fragment>
              <div className="header-title">
                <div className="title-main" />
              </div>

              <div className="profile-main">
                <div style={{ padding: "30px" }}>
                  <Container>
                    {/* Personal Information Section */}
                    <Row>
                      <Col md={12}>
                        <h4
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "#333",
                            marginBottom: "20px",
                            borderBottom: "1px solid #e0e0e0",
                            paddingBottom: "10px",
                          }}
                        >
                          Personal Information
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">First Name</label>
                          <input
                            name="firstName"
                            className="form-control"
                            type="text"
                            placeholder="First Name"
                            onChange={(e) => setFirstName(e.target.value)}
                            value={firstName}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">Last Name</label>
                          <input
                            name="lastName"
                            className="form-control"
                            type="text"
                            placeholder="Last Name"
                            onChange={(e) => setLastName(e.target.value)}
                            value={lastName}
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Contact Information Section */}
                    <Row>
                      <Col md={12}>
                        <h4
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "#333",
                            marginBottom: "20px",
                            marginTop: "30px",
                            borderBottom: "1px solid #e0e0e0",
                            paddingBottom: "10px",
                          }}
                        >
                          Contact Information
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">Email Address <span style={{ color: "red" }}>*</span></label>
                          <input
                            disabled
                            name="email"
                            className="form-control"
                            type="text"
                            placeholder="Email"
                            value={email}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">
                            Mobile Phone Number <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            name="mobile"
                            className="form-control"
                            type="text"
                            placeholder="Phone"
                            onChange={(e) => setMobile(e.target.value)}
                            value={mobile}
                            maxLength={16}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">
                            Secondary Email Address <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            name="recoveryEmail"
                            className="form-control"
                            type="text"
                            placeholder="Email"
                            onChange={(e) =>
                              setRecoveryEmail(e.target.value.toLowerCase())
                            }
                            value={recoveryEmail}
                          />
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              marginTop: "5px",
                            }}
                          >
                            Email address used in case account needs to be
                            recovered.
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* User Information Section */}
                    <Row>
                      <Col md={12}>
                        <h4
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "#333",
                            marginBottom: "20px",
                            marginTop: "30px",
                            borderBottom: "1px solid #e0e0e0",
                            paddingBottom: "10px",
                          }}
                        >
                          User Information
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      {/* <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">
                            Language Preference
                          </label>
                          <select
                            onChange={(e) => setLanguage(e.target.value)}
                            name="language"
                            className="select"
                            value={language}
                          >
                            <option value="en">en</option>
                            <option value="es">es</option>
                          </select>
                        </div>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">Password</label>
                          <div style={{ position: "relative" }}>
                            <input
                              onChange={(e) => setPassword(e.target.value)}
                              name="password"
                              className="form-control"
                              type={passwordShown ? "text" : "password"}
                              placeholder="••••••"
                              value={password}
                              style={{ paddingRight: "40px" }}
                            />
                            <FontAwesomeIcon
                              icon={passwordShown ? faEye : faEyeSlash}
                              onClick={togglePassword}
                              style={{
                                position: "absolute",
                                right: "13px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#666",
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginBottom: "20px" }}>
                          <label className="labelBold">Confirm Password</label>
                          <div style={{ position: "relative" }}>
                            <input
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                              onFocus={() => setShowError(false)}
                              name="confirmPassword"
                              className="form-control"
                              type={confirmPasswordShown ? "text" : "password"}
                              placeholder="••••••"
                              value={confirmPassword}
                              style={{ paddingRight: "40px" }}
                            />
                            <FontAwesomeIcon
                              icon={confirmPasswordShown ? faEye : faEyeSlash}
                              onClick={toggleConfirmPassword}
                              style={{
                                position: "absolute",
                                right: "13px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "#666",
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {showError && (
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginTop: "10px",
                            }}
                          >
                            Password and Confirm Password should be same.
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Container>
                </div>
              </div>

              <div className="profile-actions">
                <button
                  className="action-btn cancel-btn"
                  onClick={onCancelClick}
                >
                  <span>Cancel</span>
                </button>
                <button
                  className="action-btn save-btn"
                  onClick={() => onNextClick()}
                  disabled={loading}
                >
                  <span>Save Profile</span>
                  {loading && (
                    <Loader
                      type="TailSpin"
                      color="white"
                      height={20}
                      width={20}
                    />
                  )}
                </button>
              </div>
            </Fragment>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default RecruiterProfile;
